import { Typography } from '@aloft/toolkit-sui';

import { FieldPath, useFormContext } from 'react-hook-form';

import { selectEffectiveYear } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';

export const AgeWithYearBuiltField = <T, U extends string | number>({
  columnIndex,
  field,
}: PropertyGridFieldProps<T, U>) => {
  const { fieldName } = field;
  const effectiveYear = useAppSelector((state) => selectEffectiveYear(state));

  const { watch } = useFormContext<PropertyGridForm>();
  const propertyDataFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.${fieldName}`;
  const value = watch(propertyDataFieldName) as number | undefined;

  const displayValue = (() => {
    if (value === undefined) return undefined;

    const yearBuilt = effectiveYear ? parseInt(effectiveYear, 10) - value : undefined;
    const suffix = value === 1 ? 'yr' : 'yrs';

    return yearBuilt ? `${value} ${suffix} (${yearBuilt})` : `${value} ${suffix}`;
  })();

  return <Typography {...readOnlyFieldTypographyProps}>{displayValue}</Typography>;
};
